









import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'
import TaxForm from '@/components/tax/TaxForm.vue'
import taxStore from '@/stores/TaxStore'
import Tax from '@/dto/taxes/Tax'

@Component({
  components: { TaxForm },
})
export default class TaxEdit extends Vue {
  taxStore = taxStore
  tax: Tax | null = null

  @Watch('taxStore.tax', { immediate: true })
  setModel(tax: Tax) {
    this.tax = Object.assign({}, tax)
  }
}
